import { TrackerEventPriority } from "@/api/SolarCloudApi";

export enum EventType {
  DISBURSEMENT = "disbursement",
  REMINDERS = "reminders",
  INFORMATION = "information",
  ACTIONS = "required actions",
  PAYMENTS = "payments",
  ALL = "all",
}

export type EventExample = {
  type: EventType;
  timestamp?: any;
  title?: string;
  description?: string;
  priority?: TrackerEventPriority;
  update?: string;
  messages?: Array<string>;
  uuid?: string;
  entityUuid?: string;
  payload?: any;
  manualPaymentRequestUuid?: string;
  manualPaymentRequestState?: string;
  paymentMethod?: string;
  label?: string;
};

export const exampleTrackerData: EventExample[] = [
  {
    type: EventType.DISBURSEMENT,
    timestamp: "2025-06-12T12:00:00Z",
    title: "Disbursement Failed",
    priority: TrackerEventPriority.CRITICAL,
    update: "$567.34",
    messages: ["Disbursement attempt failed on 12/06/2025, 12:00pm"],
    uuid: "123",
    payload: {
      disbursementInfo: {
        disbursementType: "Bank",
        status: "Failed",
        accountIdentifier: "**** 1234",
        amount: 567.34,
        currency: "AUD",
        failureReason: "Incorrect bank details",
        note: "Account holder name mismatch"
      }
    }
  },
  {
    type: EventType.PAYMENTS,
    timestamp: "2025-05-30T12:00:00Z",
    title: "Payment Received",
    description: "Monthly payment received",
    priority: TrackerEventPriority.NORMAL,
    update: "$670.50",
    messages: [
      "Payment received for May 2025",
      "10 panels",
      "1kW",
      "20yr guarantee",
    ],
    uuid: "234",
  },
  {
    type: EventType.INFORMATION,
    timestamp: "2025-05-15T10:30:00Z",
    title: "Panels now available",
    priority: TrackerEventPriority.LOW,
    update: "50% of Panels Available",
    messages: [
      "Great news! we have 50% of your balance of virtual panels available Now.",
      "5 panels",
      "0.5kW",
    ],
    uuid: "345",
  },
  {
    type: EventType.ACTIONS,
    timestamp: "2025-04-20T14:15:00Z",
    title: "Document Verification",
    update: "Verification Required",
    description: "Please verify your documents",
    priority: TrackerEventPriority.HIGH,
    messages: ["Please upload your latest utility bill", "Due by 30/04/2025"],
    uuid: "456",
  },
  {
    type: EventType.REMINDERS,
    timestamp: "2025-04-01T09:00:00Z",
    title: "Quarterly Review",
    description: "Your quarterly performance review is available",
    update: "Q1 2025",
    priority: TrackerEventPriority.NORMAL,
    messages: ["Review your Q1 2025 performance", "Check your savings"],
    uuid: "567",
  },
  {
    type: EventType.DISBURSEMENT,
    timestamp: "2025-03-15T11:30:00Z",
    title: "Disbursement Failed",
    priority: TrackerEventPriority.CRITICAL,
    update: "$523.45",
    messages: ["Disbursement attempt failed on 15/03/2025, 11:30am"],
    uuid: "678",
    payload: {
      note: "Customer needs to be contacted to update their details.",
      disbursementInfo: {
        disbursementType: "BPay",
        status: "Failed",
        amount: 523.45,
        currency: "AUD",
        failureReason: "No BPay details provided",
        note: "System has no recorded BPay biller code for this account."
      }
    }
  },
  {
    type: EventType.PAYMENTS,
    timestamp: "2025-02-28T15:45:00Z",
    title: "Payment Received",
    description: "Monthly payment received",
    priority: TrackerEventPriority.NORMAL,
    update: "$670.50",
    messages: ["Payment received for February 2025", "10 panels", "1kW"],
    uuid: "789",
  },
  {
    type: EventType.INFORMATION,
    timestamp: "2025-02-15T13:20:00Z",
    title: "System Update",
    update: "System maintenance completed",
    priority: TrackerEventPriority.LOW,
    messages: [
      "System maintenance completed successfully",
      "All services are now operational",
    ],
    uuid: "890",
  },
  {
    type: EventType.ACTIONS,
    timestamp: "2025-01-31T16:00:00Z",
    title: "Annual Review Required",
    description: "Please complete your annual review",
    update: "Review by 15/02/2025",
    priority: TrackerEventPriority.HIGH,
    messages: ["Annual review form available", "Due by 15/02/2025"],
    uuid: "901",
  },
].sort(
  (a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
);
